<script setup lang="ts">
import { useAccordionSlot } from "./useAccordionItem";
useAccordionSlot("content");
</script>

<template>
  <slot />
</template>

<style>
:host {
  display: contents;
}
</style>
